<template>
  <section class="bottom-navbar">
    <div class="container bottom-navbar__container">
      <div class="bottom-navbar__container__left-side">

        <div class="row contacts d-md-none">

          <div class="col-md-4 contacts__info">
            <LocationIcon class="me-2 " />
            {{ $t('footer.address') }}
          </div>

          <div class="col-md-3 contacts__info">
            <MessageIcon class="me-2" />
            {{ CALL_CENTER_PHONE_NUMBER }}
          </div>

          <div class="col-md-3 contacts__info">
            <PhoneIcon class="me-2" />
            {{ EMAIL }}
          </div>

        </div>

        <div class="bottom-navbar__container__left-side__header d-block d-md-none mb-4">
          {{ $t('footer.site_copyright') }}
        </div>

        <p>{{ $t('bottom_navbar.text') }}</p>
      </div>

      <div class="bottom-navbar__container__right-side">
        <SocialLinks class="bottom-navbar__container__right-side__socials" color="#FFFFFF" />
      </div>
    </div>
  </section>
</template>

<script>
import SocialLinks from '@/components/SocialLinks';
import { CALL_CENTER_PHONE_NUMBER, EMAIL } from '@/utils/constants';
import PhoneIcon from '@/components/svg/PhoneIcon';
import LocationIcon from '@/components/svg/LocationIcon';
import MessageIcon from '@/components/svg/MessageIcon';

export default {
  name: 'BottomNavbar',
  data: () => ({
    CALL_CENTER_PHONE_NUMBER,
    EMAIL
  }),
  components: {
    LocationIcon,
    PhoneIcon,
    SocialLinks,
    MessageIcon
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/mixins/_font.scss";

.bottom-navbar {
  background-color: $black;
  padding: 24px 0;

  &__container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: $mobile) {
      align-items: start;
      flex-direction: column;
    }

    &__left-side {
      max-width: 50%;

      .contacts {
        &__info {
          @include font(18px, 500, 25px, $white);

          @media (max-width: $mobile) {
            margin-bottom: 1rem;
          }

        }
      }

      @media screen and (max-width: $mobile) {
        display: unset;
        max-width: 100%;
      }

      &__header {
        @include font(16px, 600, 20px, #989898);
      }

      p {
        @include font(14px, 400, 18px, #989898);
        margin: 0;
      }

    }

    &__right-side {
      @media screen and (max-width: $mobile) {
        display: none;
      }
    }
  }
}

</style>